import React from "react";
import PropTypes from "prop-types";
import { AlertTriangle } from "lucide-react";
import { useLanguage } from "../../context/LanguageContext.js";
import "./ErrorState.css";

const ErrorState = ({
    title,
    message,
    actionLabel,
    onAction,
    icon: Icon = AlertTriangle,
    variant = "default",
    className = "",
}) => {
    const { t } = useLanguage();
    const resolvedTitle = title ?? t("errorState.title");
    const resolvedMessage = message === undefined ? t("errorState.message") : message;
    const resolvedActionLabel = actionLabel ?? t("errorState.tryAgain");

    return (
        <div className={`error-state-card error-state-card--${variant} ${className}`.trim()} role="alert">
            <div className="error-state-card__icon" aria-hidden="true">
                <Icon size={variant === "compact" ? 20 : 28} />
            </div>
            <div className="error-state-card__content">
                <h2 className="error-state-card__title">{resolvedTitle}</h2>
                {resolvedMessage ? <p className="error-state-card__message">{resolvedMessage}</p> : null}
            </div>
            {resolvedActionLabel && onAction ? (
                <button type="button" className="error-state-card__action" onClick={onAction}>
                    {resolvedActionLabel}
                </button>
            ) : null}
        </div>
    );
};

ErrorState.propTypes = {
    title: PropTypes.string,
    message: PropTypes.string,
    actionLabel: PropTypes.string,
    onAction: PropTypes.func,
    icon: PropTypes.elementType,
    variant: PropTypes.oneOf(["default", "compact"]),
    className: PropTypes.string,
};

export default ErrorState;
